import { inject, Injectable } from '@angular/core';

import { useFirmwareStore } from '../../../+state/firmware-package/firmware-api.store';

@Injectable({
    providedIn: 'root'
})
export class DistributionService {
private apiStore = inject(useFirmwareStore);

 async getAllSupportedApps() {
    await this.apiStore.loadAllSupportedApps();
    return this.apiStore.allSupportedApps.data?.() ?? [];
  }

}
